export const ICBC_DEFAULTS = {
  cuit: '30646959876',
  currency: '0',
  prestation: 'CUOTAS',
};

export const ICBC_CURRENCY_OPTIONS = [
  { value: '0', label: 'Pesos' },
  { value: '1', label: 'Dólares' },
];

export const MONTH_OPTIONS = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];

export const generateYearOptions = (startYear = 2023) => {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + 1;
  const years = [];

  for (let year = endYear; year >= startYear; year -= 1) {
    years.push(year);
  }

  return years;
};
